import { register } from '@shopify/theme-sections'

export default register(`template-calculator`, {
  onLoad() {
    let params = new URLSearchParams(window.location.search)
    let iframe = document.getElementById(`calculator_iFrame`)

    if (
        window.Shopify.theme.role === `development` &&
        !window.location.host.includes(`shopify`)
    ) {
      let iframeurl = new URL(iframe.src)
      iframeurl.host = `localhost`
      iframeurl.protocol = `http`
      iframe.src = iframeurl.toString()
    }
    if (params.get(`calculator_amount`)) {
      let calculatorAmount = params.get(`calculator_amount`)
      let iframe = document.getElementById(`calculator_iFrame`)
      let parts = iframe.src.split(`?`)
      iframe.src = `${parts[0]}${calculatorAmount}/?${parts[1]}`
    }
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {}
})
